/* eslint-disable @typescript-eslint/no-unsafe-argument */
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import '../../../../styles/Dropdown.css';

interface Props {
  isReadOnlySection: boolean;
  isSaveLock: boolean;
  editor: any;
  setDisplayRevisionSaveModal: (value: boolean) => void;
  switchEditor: (value: string) => void;
}

/* 原稿編集画面 リビジョン処理用のプルダウン */
function RevisionCommand({ isReadOnlySection, isSaveLock, editor, setDisplayRevisionSaveModal, switchEditor }: Props) {
  const { t } = useTranslation();
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownListRef = useRef<HTMLLIElement>(null);

  useEffect(() => {
    const handleClickToCloseDropdown = (event: any) => {
      const element = dropdownListRef.current;
      if (!showDropdown || element?.contains(event.target)) return;
      setShowDropdown(false);
    };
    window.addEventListener('click', handleClickToCloseDropdown);
    return () => {
      window.removeEventListener('click', handleClickToCloseDropdown);
    };
  }, [showDropdown, dropdownListRef]);

  return (
    <div className="dropdowncontainer">
      <span
        className="dropdownopen"
        onClick={() => setShowDropdown((prevState) => !prevState)}
        ref={dropdownListRef}
        style={{ width: '100px' }}
      >
        <i className="fa-solid fa-history" />
        {t('改訂履歴')}
      </span>
      {showDropdown && (
        <ul className="dropdownlist" style={{ width: '150px' }}>
          <li
            className="dropdownitem"
            onClick={() => {
              if (!isSaveLock) {
                const vc: HTMLElement = editor.config.get('revisionHistory').viewerContainer;
                if (vc.style.display === 'none' || vc.style.display === '') {
                  setDisplayRevisionSaveModal(true);
                }
              }
            }}
          >
            {t('現在の改訂版を保存')}
          </li>
          <li
            className="dropdownitem"
            onClick={() => {
              switchEditor('editor');
              if (!isReadOnlySection) {
                // viewerContainer：リビジョン履歴ビューアーのDOM要素  改訂履歴ビューアを開いた時に表示される
                // https://ckeditor.com/docs/ckeditor5/latest/api/module_revision-history_revisionhistoryconfig-RevisionHistoryConfig.html#member-resumeUnsavedRevision
                const vc: HTMLElement = editor.config.get('revisionHistory').viewerContainer;
                if (vc.style.display === 'none' || vc.style.display === '') {
                  // viewerContainerが開いていない時
                  /* eslint @typescript-eslint/no-unsafe-call: off */
                  editor.config.get('revisionHistory').showRevisionViewerCallback();
                }
              }
            }}
          >
            {t('改訂履歴')}
          </li>
          <li
            className="dropdownitem"
            onClick={() => {
              if (!isReadOnlySection) {
                switchEditor('diff');
              }
            }}
          >
            {t('改訂履歴（DIFF）')}
          </li>
        </ul>
      )}
    </div>
  );
}
export default RevisionCommand;
